<template>
    <div id="pcm-attendance-request-component">
        <!-- Dialog - Attendance -->
        <form role="form" @submit.prevent="submitRequestAttendance">
            <el-dialog title="Yêu cầu chấm công"
                custom-class="el-dialog-body-gray" 
                :visible="dialogVisible" 
                width="500px"
                @close="$emit('closeDialog')"
            >
                <div class="row form-group">
                    <div class="col-sm-12">
                        <label class="required">Check In / Out</label>
                        <div>
                            <el-date-picker 
                                v-model="form.attendance.check_date"
                                v-validate="'required'" 
                                data-vv-name="check_date"
                                data-vv-as="Check-Date"  
                                type="datetimerange"
                                size="small" 
                                start-placeholder="Check In"
                                end-placeholder="Check Out"
                                time-arrow-control
                                format="dd/MM/yyyy HH:mm"
                                value-format="yyyy-MM-dd HH:mm"
                                :class="{'is-invalid': errors.has('check_date')}"
                                :default-time="[_.find(this.getSettings.data, {'setting_key': 'WORKING_START_TIME'}).setting_value + ':00', _.find(this.getSettings.data, {'setting_key': 'WORKING_END_TIME'}).setting_value + ':00']"
                                >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="required">Lý do</label>
                    <div>
                        <el-input :class="{'is-invalid': errors.has('note')}" type="textarea" autosize placeholder="Nhập lý do" v-model="form.attendance.note" v-validate="'required'" data-vv-name="note" data-vv-as="Lý do"></el-input>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button native-type="submit" type="primary" size="small" icon="el-icon-s-promotion" :loading="loadingState.attendance">Gửi yêu cầu</el-button>
                </div>
            </el-dialog>
        </form>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import {
    mapGetters
} from 'vuex'

//API
import API_ATTENDANCE from '@/utils/api/attendance'
export default {
    name: 'pcm-attendance-request-component',
    props: ['dialogVisible', 'initData'],
    data() {
        return {
            loadingState: {
                attendance: false
            },
            form: {
                attendance: {
                    check_date: [],
                    note: ''
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'getSettings'
        ]),
        _() {
            return _
        }
    },
    watch: {
        initData: function() {
            if (this.initData) {
                if (this.initData.id > 0) {
                    this.form.attendance.check_date = [
                        moment(this.initData.check_in).format('YYYY-MM-DD HH:mm'),
                        this.initData.check_date + ' ' + _.find(this.getSettings.data, {'setting_key': 'WORKING_END_TIME'}).setting_value
                    ]
                } else {
                    this.form.attendance.check_date = [
                        this.initData.check_date + ' ' + _.find(this.getSettings.data, {'setting_key': 'WORKING_START_TIME'}).setting_value,
                        this.initData.check_date + ' ' + _.find(this.getSettings.data, {'setting_key': 'WORKING_END_TIME'}).setting_value
                    ]
                }
            }
        }
    },
    created() {
        
    },
    methods: {
        submitRequestAttendance() {
            let self = this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    self.loadingState.attendance = true
                    let form = {
                        check_in: moment(self.form.attendance.check_date[0]).unix(),
                        check_out: moment(self.form.attendance.check_date[1]).unix(),
                        note: self.form.attendance.note
                    }
                    API_ATTENDANCE.sendRequest(self.$axios, form, function(data) {
                        self.loadingState.attendance = false
                        if (data.status) {
                            self.showMessage('success', 'Gửi yêu cầu thành công')
                            self.form.attendance = {
                                check_in: '',
                                check_out: '',
                                note: ''
                            }
                            self.$emit('success', data)
                        } else {
                            self.showMessage('error', data.error_message)
                        }
                    }, function(error) {
                        self.loadingState.attendance = false
                    }) 
                }
            })
        }
    },
}
</script>